import React, {useMemo} from 'react';
import {useSearchParams} from 'react-router';
import _ from 'lodash';
import {Stack, Typography} from '@mui/material';
import {useQuery} from '@tanstack/react-query';
import api from '../../util/api.js';
import {useLoaderState} from '../../components/Loader.js';

const TarotmailCustomerUnsubscribe = ()=>{
    let [params] = useSearchParams();
    let [customerId, email] = useMemo(
        ()=>[params.get('customerId'), params.get('email')],
        [params]);
    let {data, isLoading} = useQuery({
        queryKey: ['unsubscribe', {customerId, email}],
        queryFn: ()=>api.tarotmail.unsubscribe(customerId, email),
        enabled: !!(customerId&&email),
    });
    useLoaderState(isLoading);
    if (!data?.ok)
        return null;
    return <Stack direction="column" justifyContent="center" gap={2} marginTop={4}>
      <Typography variant="h3">
        הוסרת מרשימת התפוצה בהצלחה
      </Typography>
      <Typography variant="h4">{email}</Typography>
    </Stack>;
};

export default TarotmailCustomerUnsubscribe;
